
document.addEventListener("DOMContentLoaded", function () {
  // Sticky Header on Scroll
  window.addEventListener("scroll", function () {
    //if (window.scrollY > 150) {
    const currentScroll = window.pageYOffset;
    if (currentScroll > 150) {
      document.querySelector(".header_sticky")?.classList.add("menufixed");
      document.body.classList.add("header-fixed", "cart-top");
    } else {
      document.querySelector(".header_sticky")?.classList.remove("menufixed");
      document.body.classList.remove("header-fixed", "cart-top");
    }
  });

//   const header = document.querySelector(".page-header");
// const toggleClass = "is-sticky";

// window.addEventListener("scroll", () => {
//   const currentScroll = window.pageYOffset;
//   if (currentScroll > 150) {
//     header.classList.add(toggleClass);
//   } else {
//     header.classList.remove(toggleClass);
//   }
// });

  // Disable Scroll Animation Interruption
  function disableScroll() {
    window.removeEventListener("wheel", disableScroll);
    window.removeEventListener("keydown", disableScroll);
  }

  window.addEventListener("wheel", disableScroll);
  window.addEventListener("keydown", disableScroll);

  // Smooth Scroll for On-Page Links
  document.querySelectorAll(".header .header__inline-menu ul li a.onpage").forEach(link => {
    link.addEventListener("click", function (event) {
      const hash = this.hash;
      const target = document.querySelector(hash);

      if (target) {
        event.preventDefault();
        const headerHeight = document.querySelector(".header")?.offsetHeight || 0;
        const offset = 100;
        const position = target.offsetTop - headerHeight - offset;

        window.scrollTo({
          top: position,
          behavior: "smooth"
        });

        history.replaceState(null, null, hash);
      }
    });
  });

  // Accordion Toggle
  document.querySelectorAll(".ctm_rich_accordion_heading").forEach(accordion => {
    accordion.addEventListener("click", function () {
      const content = this.nextElementSibling;
      const isActive = this.classList.contains("active");
  
      document.querySelectorAll(".ctm_rich_accordion_heading").forEach(item => {
        if (item !== this) {
          item.classList.remove("active");
          if (item.nextElementSibling) {
            item.nextElementSibling.style.maxHeight = null;
          }
        }
      });
  
      this.classList.toggle("active", !isActive);
      content.style.maxHeight = !isActive ? content.scrollHeight + "px" : null;
    });
  });

    //  document.querySelectorAll('.header_dropmenu').forEach((menu) => {
    //   let timer;
    //   menu.addEventListener('mouseenter', () => {
    //     clearTimeout(timer);
    //     menu.classList.add('open');
    //   });
    //   menu.addEventListener('mouseleave', () => {
    //     timer = setTimeout(() => {
    //       menu.classList.remove('open');
    //     }, 1000); // delay before hiding
    //   });
    // });
  document.querySelectorAll(".notify-when-available-btn").forEach((btn) => {
  btn.addEventListener("click", () => {
    console.log("clicked:", btn.dataset.productId);

    const popup = document.getElementById("notify-popup");
    if (popup) {
      popup.classList.remove("hidden");
      document.querySelector(".ctm_overlay").classList.add("ctm_overlay_open");

      // Optionally pass product id into popup
      popup.setAttribute("data-product-id", btn.dataset.productId);
    }
  });
});

// Close popup
const closeBtn = document.querySelector(".notify-popup__close");
if (closeBtn) {
  closeBtn.addEventListener("click", () => {
    const popup = document.getElementById("notify-popup");
    if (popup) {
      popup.classList.add("hidden");
      document.querySelector(".ctm_overlay").classList.remove("ctm_overlay_open");
    }
  });
}


  if (closeBtn) {
    closeBtn.addEventListener("click", () => {
      popup.classList.add("hidden");
      document.querySelector(".ctm_overlay").classList.remove("ctm_overlay_open");
    });
  }
});

